<template>
  <li class="list-group-item d-flex justify-content-between align-items-center">
    {{ numbers.number }}
    <span class="badge badge-primary badge-pill">{{ numbers.total }} times</span>
  </li>
</template>
<script type="text/babel">
  import axios from 'axios';
	export default {
      props: ['numbers'],
      data() {
          return {
              editing: false
          }
      },
      methods: {
          onEdit() {
              this.editing = true;
          },
          onCancel() {
              this.editing = false;
          }
      }
  }
</script>
<style scoped>
a {
        cursor: pointer;
    }
.quote {
        display: block;
        margin-left: auto;
        margin-right: auto;
        /*min-height: 125px;*/
    }
.quote-holder {
        background: #ffffff;
        margin-bottom: 3px;
        position: relative;
        overflow: hidden;
        padding: 10px;
        min-height: 20px;
    }
.quote_btn {
        border-radius: 0;
        width: 100%;
        display: block;
        cursor: pointer;
    }
.quote_control {
        width: 100%;
        display: flex;
        padding: 15px 5px 5px;
        background: #FFF;
    }
.control_1 {
        flex: 2;
    }
.control_2 {
        flex: 1;
        /*display: flex;*/
        justify-content: flex-end;
        align-items: center;
        font-size: 20px;
        font-weight: bold;
        color: #51D2B7;
    }
#form__group{
        box-sizing: border-box;
        overflow: hidden;
    }
textarea {
        margin: 10px 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/number.vue